export default __webpack_public_path__ + "static/media/logo--white.fb36bbfb.svg";